import proBadgeSrc from 'images/icons/pro-badge-white-bg.svg';
import logoSrc from 'images/icons/cuttlefish/logo.svg';
import { useIntl } from 'react-intl';
import * as styles from './GiftCard1.module.scss';
import giftCardSvg from './gc-1.svg';

function GiftCard1() {
  const intl = useIntl();

  return (
    <div className={styles.gc}>
      <img alt={intl.formatMessage({ defaultMessage: 'AllTrails gift subscription' })} className={styles.img} src={giftCardSvg} />
      <img alt={intl.formatMessage({ defaultMessage: 'AllTrails Pro' })} className={styles.badge} src={proBadgeSrc} />
      <img alt={intl.formatMessage({ defaultMessage: 'AllTrails' })} className={styles.logo} src={logoSrc} />
    </div>
  );
}

export default GiftCard1;
